import { Component, HostBinding, signal } from '@angular/core';
import { PAGES } from '@constants/constants';
import { LayoutComponent } from '@layout/layout.component';
import { AbbCommonModule } from 'app/abb-common.module';
import { TPipe, TRANSLATION_PREFIX } from "@pipes/t.pipe";;

@Component({
  selector: 'abb-settings',
  standalone: true,
  template: `
    <page-layout class="h-full" [page]="PAGES.SETTINGS" [title]="'Settings' | t"/>
  `,
  styles: ``,
  imports: [LayoutComponent, AbbCommonModule, TPipe],
  host: {
    class: 'flex-1'
  },
  providers: [{ provide: TRANSLATION_PREFIX, useValue: 'settings' }],
})
export class SettingsComponent {
  @HostBinding('attr.id') componentid = 'settings-component';
  readonly PAGES: PAGES = PAGES;
}
